var DialogAlertComponent = /** @class */ (function () {
    function DialogAlertComponent(archived) {
        this.archived = archived;
    }
    return DialogAlertComponent;
}());
export { DialogAlertComponent };
